import React from 'react'

import type { TAnalysisTypeStatus } from '@homepal/api-contract'

import { useAnalysisTypes } from 'redux/hooks/AnalysisTypes'
import { useTranslation } from 'language/translator'
import { useQuery } from 'utils/hooks'

import AnalysisTypesStatusOverview from 'components_new/organisms/analysis_types/AnalysisTypesStatusOverview'
import AnalysisTypesTable from 'components_new/organisms/analysis_types/AnalysisTypesTable'

import PageLayout from 'components_new/templates/PageLayout'

const AnalysisTypes = () => {
  const { t } = useTranslation()
  const { analysisTypes } = useAnalysisTypes()

  const { query, setQuery } = useQuery()

  const status = (query['status'] || null) as TAnalysisTypeStatus | null

  return (
    <PageLayout
      rightSidebar={{
        content: (
          <AnalysisTypesStatusOverview
            analysisTypes={analysisTypes}
            setStatus={(value) => setQuery({ status: value })}
            status={status}
            sx={{ mt: 1 }}
          />
        ),
        size: 'small'
      }}
      topbar={{
        breadcrumbs: [
          {
            href: '/analyses-types',
            icon: { name: 'AnalysisTypes' },
            title: t('analysis_types', 'analysis_types')
          }
        ]
      }}
      variant="static"
    >
      <AnalysisTypesTable status={status} sx={{ flex: 1 }} />
    </PageLayout>
  )
}

export default AnalysisTypes
